module.exports = __webpack_public_path__ + "static/media/invoice-payment-history.df855c47.svg";